import { ApolloQueryResult, useQuery } from '@apollo/client'
import { useParams } from 'react-router-dom'

import {
  getDoctorPatientProfile,
  getDoctorPatientProfileVariables,
} from '../../../../models/graphqlTypes'
import { GET_DOCTOR_PATIENT_PROFILE } from '../operations/doctorPatientOperations'
import {
  DoctorPatientProfile,
  DoctorPatientRouteParams,
} from '../types/doctorPatients.types'

type Props = {
  skip: boolean
}

type ReturnData = {
  patientProfile?: DoctorPatientProfile
  loading: boolean
  refetch: (
    variables?: Partial<getDoctorPatientProfileVariables> | undefined
  ) => Promise<ApolloQueryResult<getDoctorPatientProfile>>
}

export const useDoctorPatientProfileData = ({ skip }: Props): ReturnData => {
  const { patientId } = useParams<DoctorPatientRouteParams>()
  const { data, loading, refetch } = useQuery<
    getDoctorPatientProfile,
    getDoctorPatientProfileVariables
  >(GET_DOCTOR_PATIENT_PROFILE, {
    variables: {
      patientId: patientId || '',
    },
    skip: !patientId || skip,
  })

  const patientProfile = data?.getPatientProfile

  return {
    patientProfile,
    loading,
    refetch,
  }
}
